import {Component, OnInit} from '@angular/core';
import {StepperService} from '../../../../projects/mydocma/import-export/src/lib/stepper/stepper.service';
import {stepperConfig} from '../config/import/stepper-config';
import {fieldsToImportConfig} from '../config/import/fields-to-import-config';
import {ExecutionService} from '../../../../projects/mydocma/import-export/src/lib/stepper/execution/execution.service';
import {ExecutionItem} from '../../../../projects/mydocma/import-export/src/lib/stepper/execution/execution-item';
import {ExecutionStateEnum} from '../../../../projects/mydocma/import-export/src/lib/stepper/execution/execution-state.enum';

@Component({
    selector: 'app-layouts',
    templateUrl: './import.component.html',
    styleUrls: ['./import.component.scss']
})
export class ImportComponent implements OnInit {

    public fieldsToImportConfig = fieldsToImportConfig;

    public items = [
        new ExecutionItem({
            name: 'import',
            text: 'Import is in progress...',
            icon: 'done',
            progress: 30
        })
    ];

    constructor(
        public stepperService: StepperService,
        public executionService: ExecutionService
    ) {
        this.stepperService.init(stepperConfig, null, new Map());

        const step3 = this.stepperService.getStepByName('fileDataMapping');
        step3.data = {nr: 'nr', name: 'name', age: 'age', country: 'country', nationality: 'nationality'};
    }

    public ngOnInit() {
        const selectFileData = {
            columnHeaders: ['nr', 'name', 'country', 'nationality', 'age'],
            data: [
                ['nr', 'name', 'country', 'nationality', 'age'],
                [1, null, 'ukraine', 'ukrainian', 14],
                [2, 'Michael', 'usa', null, 14],
                [3, 'Yura', 'usa', null, '22']
            ],
            fileName: 'Book1.xlsx',
            sheetName: 'Sheet1'
        };

        const stepSelectFile = this.stepperService.getStepByName('selectFile');
        stepSelectFile.data = selectFileData;
    }

    public setData() {
        const stepSelectFile = this.stepperService.getStepByName('selectFile');
        const stepDataMapping = this.stepperService.getStepByName('fileDataMapping');
        const stepFilePreview = this.stepperService.getStepByName('filePreview');

        const step = this.stepperService.getStepByName('filePreview');
        stepFilePreview.component.enter();
    }

    public step4InitTable() {
        this.executionService.end();
    }

    public step4Init() {
        this.executionService.end();
    }

    public step4Start() {
        this.executionService.start(this.items);
    }

    public step4SetImportProgress(type) {
        if (type === 'inProgress') {
            this.items[0].text = 'Import is in progress...';
            this.items[0].state = ExecutionStateEnum.Running;

            return;
        }
        if (type === 'done') {
            this.items[0].text = 'Import was successful';
            this.items[0].state = ExecutionStateEnum.Completed;

            return;
        }
    }
}

